document.addEventListener('DOMContentLoaded', function () {
  // Get elements for Delivery and Pickup buttons
  const deliveryBtn = document.getElementById('cart-delivery-btn');
  const pickupBtn = document.getElementById('cart-pickup-btn');
  const pickupContainer = document.querySelector('.cart-pickup-container');
  
  // Elements for Pickup date and time fields
  const dateInput = document.getElementById('cart-pickup-date');
  const timeInput = document.getElementById('cart-pickup-time');
  const timeContainer = document.getElementById('cart-time-container'); // Time container for time select
  
  // Initialize the page to default to Delivery option active
  function initialize() {
    pickupContainer.classList.add('hidden'); // Hide the pickup fields initially
    deliveryBtn.classList.add('active'); // Set Delivery as the active button by default
    pickupBtn.classList.remove('active'); // Ensure Pickup is not active
    restrictPastDates(); // Restrict past dates for the date picker
    populateTimeOptions(); // Populate time options for today (default)
  }

  // Toggle between Delivery and Pickup
  deliveryBtn.addEventListener('click', function () {
    pickupContainer.classList.add('hidden'); // Hide the pickup fields
    deliveryBtn.classList.add('active'); // Highlight Delivery button
    pickupBtn.classList.remove('active'); // Unhighlight Pickup button
    clearPickupFields(); // Clear pickup date/time fields when Delivery is selected
    updateCartAttributes(); // Ensure cart is updated to remove pickup option

    const checkoutBtn = document.querySelector('#checkout');
    if(checkoutBtn){
      checkoutBtn.disabled = false;
    }
  });

  pickupBtn.addEventListener('click', function () {
    pickupContainer.classList.remove('hidden'); // Show the pickup fields
    pickupBtn.classList.add('active'); // Highlight Pickup button
    deliveryBtn.classList.remove('active'); // Unhighlight Delivery button
    updateCartAttributes(); // Ensure cart is updated with pickup option

    const checkoutBtn = document.querySelector('#checkout');
    if(checkoutBtn){
      checkoutBtn.disabled = true;
    }
  });

  // Function to clear pickup fields when Delivery is selected
  function clearPickupFields() {
    dateInput.value = ''; // Clear date input
    timeInput.value = ''; // Clear time input
    timeContainer.classList.add('hidden'); // Hide the time select container
  }

  // Ensure past dates are not selectable in the date input
  function restrictPastDates() {
    const currentDate = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
    dateInput.setAttribute('min', currentDate); // Set the 'min' attribute to today's date
  }

  // Populate the time options based on the selected date or current date (if no date selected)
  function populateTimeOptions(selectedDate = new Date()) {
    const currentDate = new Date();
    let startTime;
    const endTime = 18 * 60; // End time (6:00 PM) in minutes

    // Clear existing options
    timeInput.innerHTML = '';

    if (selectedDate.toDateString() === currentDate.toDateString()) {
      // If today, set start time to next hour rounded up
      const currentTimeInMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();
      startTime = Math.ceil(currentTimeInMinutes / 60) * 60 + 60; // Round up to next hour + 1 hour
      // Ensure start time is at least 12:00 PM
      startTime = Math.max(startTime, 12 * 60);
    } else {
      // If future date, start at 12:00 PM
      startTime = 12 * 60;
    }

    // Generate hourly time slots
    for (let time = startTime; time <= endTime; time += 60) {
      const displayTime = `${formatTime(Math.floor(time/60), 0)} - ${formatTime(Math.floor(time/60) + 1, 0)}`;
      
      const option = document.createElement('option');
      option.value = displayTime;
      option.textContent = displayTime;
      timeInput.appendChild(option);
    }
  }

  // Format time in HH:MM format
  function formatTime(hours, minutes) {
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    return `${formattedHours}:${formattedMinutes}`;
  }

  // Event listener for the date input change
  dateInput.addEventListener('change', function () {
    const selectedDate = new Date(dateInput.value);
    populateTimeOptions(selectedDate); // Repopulate the time options based on the selected date
    timeContainer.classList.remove('hidden'); // Show the time picker when a date is selected
    updateCartAttributes(); // Update the cart with the new date and time
  });

  // Event listener for the time input change
  timeInput.addEventListener('change', function () {
    updateCartAttributes(); // Update the cart with the selected time and (if selected) date
  });

  // Update cart attributes when either field changes
  function updateCartAttributes() {
    const attributes = {
      'pickup-date': dateInput.value || null,
      'pickup-time': timeInput.value || null,
    };

    // Check if both date and time are selected before sending the update
    if (!attributes['pickup-date'] || !attributes['pickup-time']) return;

    // Add pickup attribute if pickup is selected
    if (pickupBtn.classList.contains('active')) {
      attributes['pickup-option'] = 'Click and collect'; // Indicate that the pickup option is selected
    } else {
      attributes['pickup-option'] = null; // Clear the pickup option if unchecked
    }

    if(attributes['pickup-date'] && attributes['pickup-time']){
      const checkoutBtn = document.querySelector('#checkout');
      if(checkoutBtn){
        checkoutBtn.disabled = false;
      }
    }

    // Shopify AJAX API to update cart attributes
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartDisplay(attributes);
      refreshDrawerShippingOptions();
    })
    .catch(error => console.error('Error updating cart attributes:', error));
  }

  function refreshDrawerShippingOptions() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.toggleStandardShippingOptionForDhlOnly !== 'function') return;
    cartDrawer.toggleStandardShippingOptionForDhlOnly();
  }

  // Update the cart display without reloading
  function updateCartDisplay(attributes) {
    document.querySelector('.pickup-date-display').textContent = 'Pickup Date: ' + attributes['pickup-date'];
    document.querySelector('.pickup-time-display').textContent = 'Pickup Time: ' + attributes['pickup-time'];
  }

  initialize(); // Initialize the form on load

  // Listen for cart changes and reload the page
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(async (response) => {
      const url = response.url;
      if (url.includes('/cart/change') && args[1]?.method === 'POST') {
        await response.json(); // Wait for the response to be processed
        initialize();
      }
      return response;
    });
  };
});
